import React from 'react';
import { whyChoose } from '../mock/data';
import { useReveal, useCounter } from '../hooks/useReveal';
import { ArrowRight } from 'lucide-react';

function Stat({ num, suffix = '', label, sub }) {
  const { ref, inView } = useReveal();
  const val = useCounter(num, 1500, inView);
  return (
    <div ref={ref} className={`reveal ${inView ? 'in-view' : ''} rounded-2xl bg-white border border-[var(--pca-border)] p-6 shadow-[0_20px_40px_-30px_rgba(11,46,110,0.35)]`}>
      <div className="text-3xl md:text-4xl font-extrabold text-[#0B2E6E]">{val.toLocaleString()}{suffix}</div>
      <div className="text-slate-600 mt-1 text-sm">{label}</div>
      {sub && <div className="text-[12px] text-slate-500 mt-1">{sub}</div>}
    </div>
  );
}

function Point({ item, i }) {
  const { ref, inView } = useReveal();

  const content = (
    <>
      <div className="shrink-0 w-11 h-11 rounded-xl bg-[var(--pca-blue-soft)] text-[var(--pca-blue)] font-extrabold flex items-center justify-center">
        {item.num}
      </div>

      <div>
        <h4 className="font-bold text-[#0B2E6E]">{item.title}</h4>
        <p className="text-slate-600 text-[14px] mt-1 leading-relaxed">
          {item.desc}
        </p>
      </div>
    </>
  );

  if (item.num === '08') {
    return (
      <a
        ref={ref}
        href="/bpharm-lateral-entry-students"
        style={{ transitionDelay: `${(i % 3) * 100}ms` }}
        className={`reveal ${inView ? 'in-view' : ''} lift rounded-2xl bg-white border border-[var(--pca-border)] p-6 flex gap-4 hover:shadow-lg transition-shadow cursor-pointer`}
      >
        {content}
      </a>
    );
  }

  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${(i % 3) * 100}ms` }}
      className={`reveal ${inView ? 'in-view' : ''} lift rounded-2xl bg-white border border-[var(--pca-border)] p-6 flex gap-4`}
    >
      {content}
    </div>
  );
}

export default function WhyChoose() {
  const { ref, inView } = useReveal();
  return (
    <section id="facilities" className="py-20 md:py-28 bg-white">
      <div className="container-x">
        <div ref={ref} className={`reveal ${inView ? 'in-view' : ''} grid lg:grid-cols-2 gap-10 items-start`}>
          <div>
            <span className="section-eyebrow">WHY CHOOSE US</span>
            <h2 className="section-title mt-4 text-[34px] md:text-[44px] leading-tight">A legacy of excellence in pharmacy education</h2>
            <p className="mt-4 text-slate-600">
              For over two and a half decades, Pharmacy College Azamgarh has been a trusted name in shaping successful pharmacy professionals. Our commitment to quality education, modern infrastructure, and holistic development sets us apart.
            </p>
            <a href="#about" className="btn-primary mt-6">Learn About Us <ArrowRight size={16} /></a>
          </div>

          <div className="grid sm:grid-cols-3 gap-4">
            <Stat num={3000} suffix="+" label="Alumni working globally" />
            <Stat num={92} suffix="%" label="Placement Rate" />
            <Stat num={1999} label="Established" sub="Legacy of 26+ Years" />
          </div>
        </div>

        <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {whyChoose.map((w, i) => <Point key={w.num} item={w} i={i} />)}
        </div>
      </div>
    </section>
  );
}
